module.exports = __webpack_public_path__ + "static/media/facebook_new.3bdcdd21.svg";